import { ErrorStatus } from '@/app/components/error-layout/status';
import { Footer } from '@/app/components/layouts/footer';
import { TopNavigationFilled } from '@/app/components/layouts/top-navigation/layouts/filled';
import { ERROR_DATA } from '@/app/contents/error-layout';
import { FOOTER_CONTACT } from '@/app/contents/footer';
import { LogoIsuzu } from '@/app/lcv/components/logo/isuzu';
import { FOOTER_BUYING_TOOLS, FOOTER_NAV } from '@/app/lcv/contents/footer';
import { NAV_BUYING_TOOLS, NAV_MENUS } from '@/app/lcv/contents/top-navigation';
import type { ErrorStatusType } from '@/app/types/error-layout';

const DATA = {
  imageMobile: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt29c2126d778b9fa1/67441f4c4d7c439673f6179c/404-mobile.jpg',
    width: 1600,
    height: 1600,
  },
  imageDesktop: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta6a89ba14eeba043/67441f4c0da03c7a7eb52c23/404-desktop.jpg',
    width: 1600,
    height: 600,
  },
};

interface ErrorLcv {
  status: ErrorStatusType;
}

export const ErrorLcv = ({ status }: ErrorLcv) => {
  return (
    <>
      <TopNavigationFilled
        logo={<LogoIsuzu className="w-24" />}
        vehicleType="lcv"
        items={NAV_MENUS}
        buyingTools={NAV_BUYING_TOOLS}
      />
      <main>
        <ErrorStatus
          title={ERROR_DATA[status].title}
          description={ERROR_DATA[status].description}
          imageDesktop={DATA.imageDesktop}
          imageMobile={DATA.imageMobile}
        />
        <Footer
          buyingTools={FOOTER_BUYING_TOOLS}
          contact={FOOTER_CONTACT}
          nav={FOOTER_NAV}
        />
      </main>
    </>
  );
};
